import AppStorage from "@/lib/appStorage";

export const NSFW_USER_SETTING = "NSFW_USER_SETTING";

export const getStorageNSFWUserSettings = () => {
  const value = AppStorage.getNumber(NSFW_USER_SETTING, -1);
  return value === -1 ? null : Boolean(value);
};

export const setNSFWUserSettings = (value: boolean) => {
  AppStorage.setNumber(NSFW_USER_SETTING, Number(value));
};
